export default {"src":"/_next/static/media/relaxed.f7c6006c.svg","height":60,"width":72,"blurWidth":0,"blurHeight":0};